import React, { useState } from "react";
import {
  BackgroundColorContext,
  backgroundColors,
} from "contexts/BackgroundColorContext";

const BACKGROUND_COLOR_STORAGE_KEY = "userBackgroundColorPreference";

export default function BackgroundColorWrapper(props) {
  // Load background color from localStorage or default to blue
  const getInitialColor = () => {
    if (typeof window !== "undefined") {
      const savedColor = localStorage.getItem(BACKGROUND_COLOR_STORAGE_KEY);
      if (savedColor && Object.values(backgroundColors).includes(savedColor)) {
        return savedColor;
      }
    }
    return backgroundColors.blue;
  };

  const [color, setColor] = useState(getInitialColor);

  function changeColor(newColor) {
    setColor(newColor);
    // Save to localStorage
    if (typeof window !== "undefined") {
      localStorage.setItem(BACKGROUND_COLOR_STORAGE_KEY, newColor);
    }
  }

  return (
    <BackgroundColorContext.Provider
      value={{ color: color, changeColor: changeColor }}
    >
      {props.children}
    </BackgroundColorContext.Provider>
  );
}
